import { DatabaseUser } from "./database-user.entity";

export class LoginUserDatabase {
    raw: DatabaseUser;
}
